<template>
  <div class="student-detail-card">
    <div class="d-flex justify-center">
      <div class="d-flex align-center justify-space-around mb-4 custome-w">
        <div class="type-filter-btn"
             :class="{'filter-active': activeFilterType === FILTER_SUBJECT_TYPE.ALL}"
             @click="handleFilterType(FILTER_SUBJECT_TYPE.ALL, true)">
          Tất cả ({{studentClasses.length}})
        </div>
        <div class="type-filter-btn"
             :class="{'filter-active': activeFilterType === FILTER_SUBJECT_TYPE.TUTOR}"
             @click="handleFilterType(FILTER_SUBJECT_TYPE.TUTOR, true)">Tutor ({{totalTutorClass}})</div>
        <div class="type-filter-btn"
             :class="{'filter-active': activeFilterType === FILTER_SUBJECT_TYPE.DUO}"
             @click="handleFilterType(FILTER_SUBJECT_TYPE.DUO, true)">Duo ({{totalDuoClass}})</div>
      </div>
    </div>
    <switch-subject v-if="activeFilterType === FILTER_SUBJECT_TYPE.DUO" class="mb-2"></switch-subject>
    <div style="font-weight: bold; font-size: 13px; color: black">TẤT CẢ CÁC LỚP ĐANG HỌC ({{computedCountTotalClasses}})</div>
    <div
      id="style-3"
      class="d-flex w-100 overflow-auto mt-4 pb-2"
    >
      <div class="subject-filter-btn mr-3"
           :class="{'active-subject-filter': activeFilterSubject === program.name}"
           v-for="(program, index) in computedClassesFilter" :key="'program' + index"
           @click="handleFilterSubject(program)"
      >
        <span>
          <span v-if="program.type && program.type === 'tutor' && program.value !== 0">T - </span>
          <span v-if="program.type && program.type === 'duo'">D - </span>
          {{program.name}}
        </span>
      </div>
    </div>
    <div style="max-height: 409px; overflow: auto" id="style-2" class="mt-6">
      <StudentClassCard
        v-for="(item, index) in studentClassesFilter"
        :key="'programCard' + index"
        :classInfo="item"
        :class="`${index === 0 ? '' : 'mt-4'}`"
      ></StudentClassCard>
    </div>
  </div>
</template>

<script>
import { TYPE_CURRICULUM_OBJ } from '@/helpers/constant';
import mapSubject from '@/mixins/mapSubject';
import SwitchSubject from '@/modules/duo_care/components/detail/SwitchSubject.vue';
import {
  FILTER_SUBJECT_TYPE,
  CLASS_STATUS_PRIORITY,
  DUO_CLASS_TYPE,
} from '@/modules/student_detail_bt/const';
import StudentClassCard from '@/modules/student_detail_bt/components/StudentClassCard.vue';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import StudentCareServices from '@/services/StudentCareServices';

import BlendedCareRepository from '@/services/BlendedCareRepository';

export default {
  name: 'StudentClassesDetail',
  components: {
    StudentClassCard,
    SwitchSubject,
  },
  mixins: [mapSubject],
  data() {
    return {
      FILTER_SUBJECT_TYPE,
      computedClassesFilter: [],
      studentClassesFilter: [],
      studentClasses: [],
      classesFilter: [],
      windowWidth: window.innerWidth,
      selfStudyCourses: [],
      isExistSelfStudy: false,
    };
  },
  async created() {
    Bus.$on('filter-tutor-program', (program) => {
      this.handleFilterSubject(program);
    });
  },
  async mounted() {
    const loading = this.$loading.show();
    await Promise.all([
      this.checkIsExistSelfStudy(),
      this.getListProgram(),
    ]);
    await this.getClassesTutor();
    await this.getClassesDuo();
    if (this.isExistSelfStudy) {
      await this.getSelfStudyCourse();
    }
    loading.hide();
    this.studentClassesFilter = _.cloneDeep(this.studentClasses.sort((a, b) => a.status_priority - b.status_priority));
    this.computedClassesFilter = _.cloneDeep(this.classesFilter);
  },
  computed: {
    ...mapState('student_detail_bt', ['activeFilterType', 'activeFilterSubject', 'studentBlendedTutorDetail']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    ...mapState('duo_care', ['activeClass']),
    computedCountTotalClasses() {
      if (this.activeFilterType === FILTER_SUBJECT_TYPE.DUO) {
        return this.studentClasses.filter((e) => e.class_type === 'duo' && e.duo_class_type === this.activeClass).length;
      } if (this.activeFilterType === FILTER_SUBJECT_TYPE.TUTOR) {
        return this.totalTutorClass;
      } return this.studentClasses.length;
    },
    totalDuoClass() {
      return this.studentClasses.filter((e) => e.class_type === 'duo').length;
    },
    totalTutorClass() {
      return this.studentClasses.filter((e) => e.class_type === 'tutor').length;
    },
  },
  watch: {
    activeClass() {
      this.handleFilterType(FILTER_SUBJECT_TYPE.DUO, true);
    },
  },
  methods: {
    ...mapActions('duo_care', ['setActiveTab']),
    ...mapActions('student_detail_bt', ['changeActiveFilterType', 'changeActiveFilterSubject', 'setActiveProgramSubjectId', 'setDataCurriculumIds', 'setDataActiveCurriculumId']),
    ...mapMutations('student_detail_bt', ['SET_ACTIVE_FILTER_TYPE', 'SET_ACTIVE_FILTER_SUBJECT']),
    ...mapActions('student_care', ['getListStudentClass', 'getListProgram']),
    async checkIsExistSelfStudy() {
      const res = await StudentCareServices.fgGetListCareBlender({
        obj: 'routine',
        attrs: [
          'type_curriculum',
        ],
        'filters[$eq__lms_core_user_id]': this.studentBlendedTutorDetail?.lms_core_user_id,
      });
      if (res.success) {
        if (res.data.some((e) => e.type_curriculum === TYPE_CURRICULUM_OBJ.IELTS_COURSE)) {
          this.isExistSelfStudy = true;
        }
      }
    },
    handleFilterType(type, isClick = false) {
      if (type === FILTER_SUBJECT_TYPE.ALL) {
        this.computedClassesFilter = this.classesFilter;
        this.studentClassesFilter = _.cloneDeep(this.studentClasses.sort((a, b) => a.status_priority - b.status_priority));
      } else if (type === FILTER_SUBJECT_TYPE.TUTOR) {
        this.computedClassesFilter = this.classesFilter.filter((e) => e.type === 'tutor');
        this.studentClassesFilter = this.studentClasses.filter((e) => e.class_type === 'tutor').sort((a, b) => a.status_priority - b.status_priority);
      } else if (type === FILTER_SUBJECT_TYPE.DUO) {
        this.computedClassesFilter = this.classesFilter.filter((e) => e.type === 'duo' && e.duo_class_type === this.activeClass);
        this.studentClassesFilter = this.studentClasses.filter((e) => e.class_type === 'duo' && e.duo_class_type === this.activeClass).sort((a, b) => a.status_priority - b.status_priority);
      }
      this.changeActiveFilterType(type);
      if (this.computedClassesFilter.length > 0 && isClick) {
        this.handleFilterSubject(this.computedClassesFilter[0]);
      }
    },
    handleFilterSubject(program) {
      this.studentClassesFilter = _.cloneDeep(this.studentClasses.sort((a, b) => a.status_priority - b.status_priority));
      if (program?.type === 'duo') {
        if (this.activeFilterType === FILTER_SUBJECT_TYPE.ALL) {
          this.handleFilterType(FILTER_SUBJECT_TYPE.DUO);
        }
        this.setActiveTab(program.duo_class_type);
        this.setActiveProgramSubjectId(program.value);
        this.setDataActiveCurriculumId(undefined);
        this.studentClassesFilter = this.studentClassesFilter.filter((e) => e.subjectId === program.value && e.duo_class_type === this.activeClass);
      } else if (program?.type === 'tutor') {
        if (this.activeFilterType === FILTER_SUBJECT_TYPE.ALL) {
          this.handleFilterType(FILTER_SUBJECT_TYPE.TUTOR);
        }
        this.setActiveProgramSubjectId(program.program_subject_id);
        this.setDataActiveCurriculumId(program.value);
        this.studentClassesFilter = this.studentClassesFilter.filter((e) => e.curriculum_id === program.value);
      } else if (!program?.value) {
        if (this.activeFilterType === FILTER_SUBJECT_TYPE.DUO) {
          this.studentClassesFilter = this.studentClassesFilter.filter((e) => e.class_type === 'duo' && e.duo_class_type === this.activeClass);
        }
        this.setActiveProgramSubjectId(undefined);
        this.setDataActiveCurriculumId(undefined);
      }
      if (program.name) {
        this.changeActiveFilterSubject(program.name);
      } else {
        this.changeActiveFilterSubject('IELTS Tự học');
      }
      Bus.$emit('change-filter-program', {
        program, // chương trình tutor/khóa học duo
        tabActive: this.activeFilterType, // Tab: Tất cả/Tutor/Duo
      });
    },
    sortAlphabet(array) {
      return array.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    async getSelfStudyCourse() {
      const result = await BlendedCareRepository.getSelfStudyCourse({
        // lms_core_user_id: 506704,
        lms_core_user_id: this.studentBlendedTutorDetail.lms_core_user_id,
      });
      if (result.message === 'Success') {
        result.data.forEach((e) => {
          this.studentClasses.push({
            ...e,
            class_type: 'tutor',
            isSelfStudy: true,
            curriculum_id: 0,
          });
        });
      }
    },
    async getClassesTutor() {
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        const params = {
          'filters[lms_core_user_id]': this.studentBlendedTutorDetail.lms_core_user_id,
          'filters[vh_class_type]': 1,
          attrs: [
            'name', 'number_lessons_passed', 'status_name', 'class_start_time', 'class_schedule', 'number_lessons',
            'status_color', 'class_level', 'contact_id', 'student_product_id', 'class_id', 'teacher_type', 'student_id',
            'teacher_full_name', 'learn_again_time', 'curriculum_id', 'join_date', 'subject_id',
          ],
        };
        const res = await this.getListStudentClass(params);
        if (res.success) {
          let tempRes = [];
          this.setDataCurriculumIds(res.data.map((e) => e.curriculum_id));
          res.data.forEach((e) => {
            e.class_type = 'tutor';
            e.status_priority = CLASS_STATUS_PRIORITY.indexOf(`${e.status_name.toLowerCase()} - tutor`);
            this.studentClasses.push(e);
            if (e.curriculum_id && this.mapProgramIdAndProgram[e.curriculum_id] && !tempRes.some((el) => el.value === e.curriculum_id)) {
              tempRes.push({
                value: e.curriculum_id,
                name: this.mapProgramIdAndProgram[e.curriculum_id]?.title,
                type: 'tutor',
                program_subject_id: e.subject_id,
              });
            }
          });
          tempRes = this.sortAlphabet(tempRes);
          if (this.isExistSelfStudy) {
            tempRes.push({
              name: 'IELTS Tự học',
              value: 0,
              type: 'tutor',
              program_subject_id: 0,
            });
          }
          tempRes.unshift({
            name: 'Tất cả',
            value: '',
          });
          this.classesFilter.push(...tempRes);
        }
      }
    },
    async getClassesDuo() {
      if (this.studentBlendedTutorDetail?.lms_core_user_id) {
        const res = await StudentCareServices.getListSubjectDetailv2({
          userId: this.studentBlendedTutorDetail.lms_core_user_id,
          // userId: 1357001,
        });
        if (res.success) {
          let sortArray = [];
          _.get(res.data, 'coursesDuo', []).forEach((e) => {
            _.get(e, 'courses', []).forEach((elm) => {
              // eslint-disable-next-line no-param-reassign
              elm.class_type = 'duo';
              // eslint-disable-next-line no-param-reassign
              elm.duo_class_type = DUO_CLASS_TYPE.DUO_CLASS;
              // eslint-disable-next-line no-param-reassign,radix
              elm.subjectId = parseInt(e.subjectId);
              // eslint-disable-next-line no-param-reassign
              elm.status_priority = CLASS_STATUS_PRIORITY.indexOf(`${elm.classStatus.toLowerCase()} - duo`);
              this.studentClasses.push(elm);
            });
            if (!sortArray.some((el) => el.value === +e.subjectId && el.duo_class_type === DUO_CLASS_TYPE.DUO_CLASS)) {
              sortArray.push({
                value: +e.subjectId,
                name: this.getSubjectById(+e.subjectId).name,
                type: 'duo',
                duo_class_type: DUO_CLASS_TYPE.DUO_CLASS,
              });
            }
          });
          _.get(res.data, 'coursesSelf', []).forEach((e) => {
            _.get(e, 'courses', []).forEach((elm) => {
              // eslint-disable-next-line no-param-reassign
              elm.class_type = 'duo';
              // eslint-disable-next-line no-param-reassign
              elm.duo_class_type = DUO_CLASS_TYPE.SELF_STUDY;
              // eslint-disable-next-line no-param-reassign,radix
              elm.subjectId = parseInt(e.subjectId);
              // eslint-disable-next-line no-param-reassign
              elm.status_priority = CLASS_STATUS_PRIORITY.indexOf(`${elm.classStatus.toLowerCase()} - duo`);
              this.studentClasses.push(elm);
            });
            if (!sortArray.some((el) => el.value === +e.subjectId && el.duo_class_type === DUO_CLASS_TYPE.SELF_STUDY)) {
              sortArray.push({
                // eslint-disable-next-line radix
                value: +e.subjectId,
                name: `${this.getSubjectById(+e.subjectId).name} (TH)`,
                type: 'duo',
                duo_class_type: DUO_CLASS_TYPE.SELF_STUDY,
              });
            }
          });
          sortArray = this.sortDuoClasses(sortArray);
          this.classesFilter.push(...sortArray);
        }
      }
    },
    arrayMove(arr, oldIndex, newIndex) {
      if (newIndex >= arr.length) {
        let k = newIndex - arr.length + 1;
        // eslint-disable-next-line no-plusplus
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
      return arr; // for testing
    },
    sortDuoClasses(duoClasses) {
      const result = this.sortAlphabet(duoClasses);
      // const sortPrioritySubject = [4, 5, 1];
      // sortPrioritySubject.forEach((el) => {
      //   if (duoClasses.some((e) => e.value === el)) {
      //     this.arrayMove(result, duoClasses.findIndex((elm) => elm.value === el), 0);
      //   }
      // });
      return result;
    },
  },
  destroyed() {
    Bus.$off('filter-tutor-program');
  },
};
</script>

<style lang="scss" scoped>
.student-detail-card {
  background: white;
  border-radius: 12px;
  width: 100%;
  padding: 16px;
  margin-bottom: 12px;
}
.type-filter-btn {
  cursor: pointer;
  background: #E0E0E0;
  color: #BDBDBD;
  font-weight: bold;
  padding: 6px;
  border-radius: 8px;
  transition: all .5s;
}
.type-filter-btn.filter-active {
  background: #6680FF;
  color: white;
}
.subject-filter-btn {
  cursor: pointer;
  color: #B2AEA6;
  background: #E0E0E0;
  border-radius: 8px;
  padding: 6px;
  height: fit-content;
  width: fit-content;
  white-space: nowrap;
  transition: all .5s;
}
.subject-filter-btn.active-subject-filter {
  background: #6A2C62;
  color: white;
}
.custome-w {
  width: 70%
}
@media screen and (max-width: 1440px) {
 .custome-w {
   width: 100%;
 }
 .student-detail-card {
  font-size: 12px !important;
 }
}
</style>
